// extracted by mini-css-extract-plugin
export var content = "pageLayout-module--content--8231d";
export var desktopNav = "pageLayout-module--desktopNav--33d97";
export var header = "pageLayout-module--header--391cd";
export var headerContent = "pageLayout-module--headerContent--91bb2";
export var headerLogo = "pageLayout-module--headerLogo--e9800";
export var main = "pageLayout-module--main--0f839";
export var mobileMenu = "pageLayout-module--mobileMenu--078d6";
export var mobileNav = "pageLayout-module--mobileNav--f1dba";
export var mobileNavClose = "pageLayout-module--mobileNavClose--85a9f";